import { render, staticRenderFns } from "./減価償却Total.vue?vue&type=template&id=2f49d4fc&scoped=true&"
import script from "./減価償却Total.ts?vue&type=script&lang=ts&"
export * from "./減価償却Total.ts?vue&type=script&lang=ts&"
import style0 from "../償却.css?vue&type=style&index=0&id=2f49d4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49d4fc",
  null
  
)

export default component.exports